import { Grid } from "@mui/material";
import { useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect, useDispatch } from "react-redux";
import { push } from "redux-first-history";
import { locationApi } from "../../../../api/LocationApi";
import CustomButton from "../../../../components/CustomButton";
import { RegisterPage } from "../../../../utils/models";
import AddressForm from "../../../User/components/AddressForm";
import InfoCircleIcon from "@mui/icons-material/InfoRounded";
import Alert from "@mui/material/Alert";
import { userSetupSlice } from "../../../../store/reducer/user_setup";
import { userSlice } from "../../../../store/reducer/user";
import { defaultAddress } from "../../../../model/address";
import { authSlice } from "../../../../store/reducer/auth";
import { ExitType } from "../../../../constants/common";
import { Box } from "@mui/system";

const AddressVerification = () => {
  const dispatch = useDispatch();
  let [address, setAddress] = useState(defaultAddress);

  let [locationError, setLocationError] = useState({
    present: false,
    message: "",
  });
  return (
    <ValidatorForm
      onSubmit={async () => {
        try {
          dispatch(authSlice.actions.startLoading());
          const validation = await locationApi.validateAddress(address);
          dispatch(authSlice.actions.finishLoading());

          if (!validation) {
            dispatch(
              userSetupSlice.actions.setExitMessageType(ExitType.OutsideCounty)
            );
            dispatch(push("/register/sorry"));
          } else {
            // If we get to this stage in code execution, any prior
            // error can be cleared
            setLocationError({
              present: false,
              message: "",
            });

            dispatch(userSlice.actions.updateUserData(address));

            dispatch(push("/register/age"));
          }
        } catch (e) {
          console.log(e);
          dispatch(
            userSetupSlice.actions.setExitMessageType(ExitType.OutsideCounty)
          );
          dispatch(push("/register/sorry"));
        } finally {
          dispatch(authSlice.actions.finishLoading());
        }
      }}
    >
      <Box component="p" className="context">
        Let’s verify your address to make sure you need to file a Springboro return.
      </Box>
      <Grid container spacing={2} className="form-container xl noexpand">
        <AddressForm address={address} setAddress={setAddress} />
      </Grid>
      {locationError.present && (
        <Alert
          severity={"error"}
          variant="outlined"
          classes={{
            root: "tax-0",
            icon: "error-icon",
          }}
          iconMapping={{
            error: <InfoCircleIcon />,
          }}
        >
          {locationError.message}
        </Alert>
      )}
      <div className="btn-container single">
        <CustomButton
          variant="contained"
          disableElevation={true}
          label={"next"}
          type="submit"
          buttonSize="btn-lg"
        />
      </div>
    </ValidatorForm>
  );
};


export default AddressVerification;
